module.exports = __webpack_public_path__ + "img/3.bcc0429a.png";